import type { FrontendWidget } from '../types';
import { SubjectsWidgetComponent } from './SubjectsWidgetComponent';
import { SubjectsWidgetComponentB } from './SubjectsWidgetComponentB';
import { SubjectsWidgetComponentC } from './SubjectsWidgetComponentC';
import type { SubjectsWidgetConfig, SubjectsWidgetResolved } from './types';

export const subjectsWidget: FrontendWidget<
  SubjectsWidgetConfig,
  SubjectsWidgetResolved
> = {
  componentType: 'widgets.subjects-widget',
  displayName: 'Subjects Widget',
  defaultValues: { subjects: [] },
  ComponentA: SubjectsWidgetComponent,
  ComponentB: SubjectsWidgetComponentB,
  ComponentC: SubjectsWidgetComponentC,
  // Lookup widget: resolved server-side by SubjectsWidgetResolver, which passes
  // through the authored fields (subjects, description zone, fallback). A
  // snippet-reference inside the description zone is resolved by
  // resolveNestedLookupWidgets. Resolved data arrives via ResolvedMapProvider —
  // so `resolveSync` is intentionally omitted.
};
